import React from 'react';
import { Header, Segment, Icon } from 'semantic-ui-react';
import { defineMessages, injectIntl } from 'react-intl';
import { INVERTED_THEME } from '../../utils/constants';

const messages = defineMessages({
  'notFound.message': {
    id: 'notFound.message',
    defaultMessage: 'Not Found'
  }
});

const NotFoundPage = injectIntl(({
  intl: {
    formatMessage
  }
}) => (
  <Segment
    basic
    textAlign='center'>
    <Header inverted={INVERTED_THEME}>
      <Icon name='cogs' />
      {formatMessage(messages['notFound.message'])}
    </Header>
  </Segment>
));

NotFoundPage.displayName = 'NotFoundPage';

export default NotFoundPage;